<script lang="ts" setup>
import imageAttention from '@/assets/images/attention.webp'

const { go } = useRouter()

const refreshPage = () => {
  go(0)
}
</script>

<template>
  <div data-test-id="some-error" class="some-error">
    <nuxt-img
      class="some-error__image"
      :src="imageAttention"
      alt="Внимание"
      data-test-id="some-error-image"
    />

    <div class="some-error__text">Страница временно не работает</div>

    <div class="some-error__message">Приносим извинения за неудобства</div>

    <the-button
      class="some-error__refresh"
      variant="tertiary"
      data-test-id="some-error-refresh-button"
      @click="refreshPage"
    >
      Обновить
    </the-button>
  </div>
</template>

<style lang="scss" scoped>
.some-error {
  padding: 130px 0 !important;
  text-align: center;

  &__image {
    width: 100%;
    max-width: 54px;
    margin: 0 auto 50px;
  }

  &__text {
    max-width: 320px;
    margin: 0 auto 20px;
    font-size: 20px;
    font-weight: 800;
    text-align: center;
  }

  &__message {
    max-width: 300px;
    margin: 0 auto 36px;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
  }

  &__refresh {
    width: 200px;
    margin: 0 auto;
  }
}
</style>
